import {useSelector} from 'react-redux';
import './Preparing.scss';
import {POPUPS} from '../../../redux/actions/app/appActionTypes';
import {useMountTransition} from '../../../helpers/hooks';
import {useTranslation} from 'react-i18next';

const Preparing = () => {
  const popupToShow = useSelector((state) => state.app.popupToShow);

  const visible = popupToShow === POPUPS.PREPARING_POPUP;

  const hasTransitionedIn = useMountTransition(visible, 1000);

  const isShow = hasTransitionedIn ? 'fade-in' : 'fade-out';
  const {t} = useTranslation();
  return (
    <div className={`preparing ${isShow}`}>
      {hasTransitionedIn && (
        <>
          <div className='preparing__grid'>
            <div className='item'></div>
            <div className='item'></div>
            <div className='item'></div>
            <div className='item'></div>
          </div>
          <div className='preparing__text'>{t('all.packageFiles')}</div>
        </>
      )}
    </div>
  );
};

export default Preparing;
